import {
  AxiosPagingResponse,
  CreateStakingErc3643PoolPayload,
  CreateStakingErc3643PoolResult,
  ResponseType,
  SearchStakingErc3643PoolsParams,
  SearchStakingErc3643TransactionsParams,
  StakingErc3643Overview,
  StakingErc3643PoolApi,
  StakingErc3643PoolsResponse,
  StakingErc3643RewardTokensResponse,
  StakingErc3643SelectablePto,
  StakingErc3643TransactionsResponse,
  UpdateStakingErc3643PoolPayload,
} from 'Modules'
import queryString from 'query-string'

import { instance } from 'api-base/instance'

const qsOpts = { skipNull: true, skipEmptyString: true }

export const stakingErc3643Api = {
  getRewardTokens(params?: { keyword?: string; page?: number; limit?: number; sort?: string }) {
    const path = queryString.stringifyUrl(
      { url: '/admin/staking-erc3643/reward-tokens', query: params },
      qsOpts
    )
    return instance.get<ResponseType<StakingErc3643RewardTokensResponse>>(path)
  },

  getOverview(rewardToken?: string) {
    const path = queryString.stringifyUrl(
      { url: '/admin/staking-erc3643/overview', query: { rewardToken } },
      qsOpts
    )
    return instance.get<ResponseType<StakingErc3643Overview>>(path)
  },

  getSelectTokenize(rewardToken?: string, keyword?: string) {
    const path = queryString.stringifyUrl(
      {
        url: '/admin/staking-erc3643/select-tokenize',
        query: { rewardToken, keyword },
      },
      qsOpts
    )
    return instance.get<ResponseType<StakingErc3643SelectablePto[]>>(path)
  },

  getPools(params?: SearchStakingErc3643PoolsParams) {
    const path = queryString.stringifyUrl(
      { url: '/admin/staking-erc3643/pools', query: params as Record<string, unknown> },
      qsOpts
    )
    return instance.get<ResponseType<StakingErc3643PoolsResponse>>(path)
  },

  getPoolDetail(id: string) {
    return instance.get<ResponseType<StakingErc3643PoolApi>>(`/admin/staking-erc3643/pools/${id}`)
  },

  getPoolTransactions(id: string, params?: SearchStakingErc3643TransactionsParams) {
    const path = queryString.stringifyUrl(
      {
        url: `/admin/staking-erc3643/pools/${id}/transactions`,
        query: params as Record<string, unknown>,
      },
      qsOpts
    )
    return instance.get<ResponseType<StakingErc3643TransactionsResponse>>(path)
  },

  // Export pool transactions as CSV (same keyword/type/sort as the list, no paging).
  exportPoolTransactions(
    id: string,
    params?: Pick<SearchStakingErc3643TransactionsParams, 'keyword' | 'type' | 'sort'>
  ) {
    const path = queryString.stringifyUrl(
      {
        url: `/admin/staking-erc3643/pools/${id}/transactions/export`,
        query: { ...params },
      },
      qsOpts
    )
    return instance.get(path, { responseType: 'blob' })
  },

  createPool(payload: CreateStakingErc3643PoolPayload) {
    return instance.post<ResponseType<CreateStakingErc3643PoolResult>>(
      '/admin/staking-erc3643/pools',
      payload
    )
  },

  updatePool(id: string, payload: UpdateStakingErc3643PoolPayload) {
    return instance.patch<ResponseType<StakingErc3643PoolApi>>(
      `/admin/staking-erc3643/pools/${id}`,
      payload
    )
  },

  updatePoolDisplay(id: string, isDisplay: boolean) {
    return instance.patch<ResponseType<{ _id: string; isDisplay: boolean }>>(
      `/admin/staking-erc3643/pools/${id}/display`,
      { isDisplay }
    )
  },
}

export type { AxiosPagingResponse }
